import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IUpdateCurrencyConversionRateDataTableRowFormMeta {
    idTable: FormInputMeta;
    nameTable: FormInputMeta;
    rateTable: FormInputMeta;
    dateTable: FormInputMeta;
    sourceTable: FormInputMeta;
    
    schema: any;
}

const UpdateCurrencyConversionRateDataTableRowFormMeta = {} as IUpdateCurrencyConversionRateDataTableRowFormMeta;

UpdateCurrencyConversionRateDataTableRowFormMeta.idTable = {
  name: "idTable",
  label: "ID",
  type: "text",
  validation: yup.string().required(),
}
UpdateCurrencyConversionRateDataTableRowFormMeta.nameTable = {
  name: "nameTable",
  label: "Nom",
  type: "text",
  validation: yup.string().required(),
}
UpdateCurrencyConversionRateDataTableRowFormMeta.rateTable = {
  name: "rateTable",
  label: "Taux",
  type: "number",
  validation: yup.string().required(),
}
UpdateCurrencyConversionRateDataTableRowFormMeta.dateTable = {
  name: "dateTable",
  label: "Date",
  type: "date",
  validation: yup.string().required(),
}
UpdateCurrencyConversionRateDataTableRowFormMeta.sourceTable = {
  name: "sourceTable",
  label: "Source",
  type: "select",
  options:  [
    {
      label: 'source 1',
      value: '1'
    },
    {
      label: 'source 2',
      value: '2',
    },
    {
      label: 'source 3',
      value: '3',
    },
  ],
  validation: yup.string().required(),
}

UpdateCurrencyConversionRateDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(UpdateCurrencyConversionRateDataTableRowFormMeta));

export default UpdateCurrencyConversionRateDataTableRowFormMeta;